<!-- 核查记录详情 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode"
                    v-filter-special-char="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch"
                    style="height: 32px">查询</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch"
                    style="height: 32px">重置</el-button>
                <div class="search-name color-red">（这里查看的是实时数据，与统计数据可能存在偏差）</div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border
                style="width: 100%; margin-bottom: 10px">
                <el-table-column prop="SpaceName" show-overflow-tooltip width="140" label="仓位"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column prop="GoodsName" show-overflow-tooltip min-width="130" label="商品名称"></el-table-column>
                <el-table-column prop="AutoSerise" show-overflow-tooltip min-width="130" label="适用车型"></el-table-column>
                <el-table-column prop="Brand" show-overflow-tooltip width="90" label="品牌"></el-table-column>
                <el-table-column prop="Cate" show-overflow-tooltip width="90" label="分类"></el-table-column>
                <el-table-column show-overflow-tooltip width="70" prop="Count" label="库存数"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" label="标签数">
                    <template slot-scope="scope">
                        <div v-if="scope.row.LableCount == 0">0</div>
                        <el-tag v-else @click="showLabelDetails(scope.row)" class="codetag">{{ scope.row.LableCount }}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="searchData.Page" :page-sizes="[10, 20, 30, 40, 50]" :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper" :total="tableDataLength"></el-pagination>
        </div>

        <el-dialog :close-on-click-modal="false" title="更多查询条件" :visible.sync="searchVisible" id="search-common-dialog"
            custom-class="search-item-dialog" :modal="false" append-to-body v-dialog-drag lock-scroll width="400px">
            <div class="dialog-content" v-if="searchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="汽配名称">
                        <el-select size="small" class="search-item" v-model="searchData.GoodName" remote filterable
                            allow-create clearable placeholder="请输入配件名称" :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad" popper-class="my-select" style="width: 100%;">
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配车型">
                        <el-select size="small" class="search-item" v-model="searchData.AutoSerise" remote filterable
                            allow-create clearable placeholder="请输入车型" :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad" popper-class="my-select" style="width: 100%;">
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item"
                                style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select size="small" style="width: 100%" :loading="selLoading" v-model="searchData.BrandName"
                            filterable clearable @visible-change="brandVisibleChange($event)">
                            <el-option label="全部" value></el-option>
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text"
                                :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select size="small" style="width: 100%" :loading="selLoading" v-model="searchData.Cate"
                            filterable clearable @visible-change="cateVisibleChange($event)">
                            <el-option label="全部" value></el-option>
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text"
                                :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="查看废品标签" :visible.sync="showLabelsDialog" width="1200px"
            append-to-body>
            <div class="dialog-content" v-if="showLabelsDialog">
                <checkWasteLabels @closeDialog="closeLabelsDialog" :SpaceId="spaceId" :GoodsId="goodsId"></checkWasteLabels>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import checkWasteLabels from '@/components/business/goods/checkWasteLabels.vue';
export default {
    name: '',
    props: ["WHId","ProjectId"],
    components: { checkWasteLabels },
    data() {
        return {
            loading: false,
            searchVisible: false,
            showLabelsDialog: false,
            selLoading: false,
            spaceId:'',
            goodsId:'',
            typeList: [],
            brandList: [],
            tableData: [],
            sIdList: [],
            tableDataLength: 0,
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            searchData: {
                ProjectId: '',
                APCode: '',
                GoodName: '',
                WarehouseId: '',
                SpaceId: '',
                BrandName: '',
                AutoSerise: '',
                Cate: '',
                Page: 1,
                Limit: 10
            },
        };
    },
    mounted() {
        if(!this.WHId)
        {
            this.$util.warningMsg('仓库数据异常，请刷新后重新操作');
            return;
        }
        this.searchData.WarehouseId = this.WHId;
        this.searchData.ProjectId = this.ProjectId;
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/DataStatistics/GetWasteGoodsDatas_ProjectVs',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        resetSearch() {
            this.searchData.APCode = '';
            this.searchData.GoodName = '';
            this.searchData.SpaceId = '';
            this.searchData.BrandName = '';
            this.searchData.AutoSerise = '';
            this.searchData.Cate = '';
            this.searchData.Page = 1;
            this.searchData.Limit = 10;
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsType() {
            this.selLoading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.sIdList.length <= 1) {
                    that.$util.getSIdList(false).then(data => {
                        that.sIdList = data;
                    });
                }
            }
        },
        showSearchDialog() {
            this.searchVisible = true;
        },
        closeSearchDialog() {
            this.searchVisible = false;
        },
        //关闭订单弹出层
        closeLabelsDialog() {
            this.detailId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.goodsId = row.GoodsId;
                this.spaceId = row.SpaceId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择商品进行查看');
                return;
            }
        },
    }
};
</script>
<style lang="less" scoped>
.tag {
    height: 24px;
    line-height: 22px;
    margin-left: 8px;
}

.codetag {
    font-size: 14px;
    border-style: none none none none;
    background-color: transparent;
    padding: 0;
    height: 11px; 
    line-height:12px
}
</style>